<div mat-dialog-title>
  Clear Player Rounds
</div>
<p>The system will clear all group rounds prior to the date provided bellow.</p> 
<p> The rounds will remain available for the player's personal handicap calculations.</p>
<mat-form-field>
  <mat-label>Date</mat-label>
  <input matInput [matDatepicker]="picker" [(ngModel)]="date" placeholder="Date" ng-model-options="{ timezone: 'utc' }" required>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
<br/>
<div fxLayout='row' fxLayoutAlign='center center'>
  <button mat-raised-button color='accent' (click)='onOk()'>Go for it!
  </button>
  <button mat-button mat-dialog-close>Nevermind</button>
</div>